export default __webpack_public_path__ + "322b38a8a37d0cfdada176307dd691c9.svg";